import { Component } from '@angular/core';

@Component({
  selector: 'icon-pencil',
  templateUrl: './icon-pencil.component.html',
  styleUrls: ['./icon-pencil.component.sass']
})
export class IconPencilComponent {}
